export default __webpack_public_path__ + "static/media/2259.3bd5bb6a.png";